import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {mapToObjectDDL} from "../../common/mapper";
import { defaultTableChange } from "../../../modules/custom/customTable";

class MasterParameterDetail extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
                sort: false,
            },
        },
        {
            name: "key",
            label: "Key",
            options: {
                customBodyRender: (val, {rowIndex, rowData}) => {
                    const isSpecialCategory = this.props.state.selectedData.category === "PAYMENT_SPECIAL_CATEGORY" && val === "PAYTYPE0002"
                    return (
                        <SimpleInput
                            id="input_text_key"
                            name="key"
                            containerclassname="margin-bottom-none"
                            value={val}
                            readOnly={rowData[rowData.length - 1] || isSpecialCategory}
                            onChange={({target}) => this.handleValueChange(rowIndex, target.name, target.value)}
                        />
                    )
                },
            },
        },
        {
            name: "value",
            label: "Nama Parameter",
            options: {
                customBodyRender: (val, {rowIndex, rowData}) => (
                    <SimpleInput
                        id="input_text_nama_parameter"
                        name="value"
                        containerclassname="margin-bottom-none"
                        value={val}
                        readOnly={rowData[rowData.length - 1]}
                        onChange={({target}) => this.handleValueChange(rowIndex, target.name, target.value)}
                    />
                ),
                sort: false,
            },
        },
        {
            name: "systemId",
            label: "Tipe Kategori",
            options: {
                customBodyRender: (val, {rowData, rowIndex}) => (
                    <SimpleDDL
                        id="select_options_tipe_kategori"
                        box="search"
                        placeholder="Tipe Kategori"
                        containerclassname="margin-bottom-none"
                        readOnly={rowData[rowData.length - 1]}
                        options={this.state.categoriesOptions}
                        value={val}
                        onChange={(value) => {
                            this.setState((prevValue) => ({
                                ...prevValue,
                                dataTable: prevValue.dataTable.map((data, idx) =>
                                    idx === rowIndex ? {...data, systemId: value} : data
                                ),
                            }));
                        }}
                    />
                ),
                setCellProps: () => ({width: "250px"}),
            },
        },
        {
            name: "saved",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const isSpecialCategory = this.props.state.selectedData.category === "PAYMENT_SPECIAL_CATEGORY" && this.state.dataTable[rowIndex]?.key === "PAYTYPE0002"
                    return (
                        <FlexView style={{gap: "10px"}}>
                            <Button
                                type="button"
                                className="btn background-red"
                                onClick={() => this.handleSaveParameter(rowIndex)}
                            >
                                {!val ? <i className="fa fa-save"/> : <i className="fa fa-lw fa-pencil-alt"/>}
                            </Button>
                            <Button
                                type="button"
                                disabled={isSpecialCategory}
                                className={isSpecialCategory? "btn background-grey" : "btn background-red"}
                                onClick={() => this.handleDeleteParameter(rowIndex)}
                            >
                                <i className="fa fa-trash"></i>
                            </Button>
                        </FlexView>
                    )
                },
                setCellProps: () => ({width: "5%"}),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            categoriesOptions: [],
            dataTable: !R.isEmpty(props.state.selectedData.data) ? props.state.selectedData.data : [],
            totalParameter: null,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    async componentDidMount() {
        await this.handleGetTotalParameter();
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterParamConfigByCategory({
            bizparCategory: this.props.state.selectedData.category,
        });
        if (response.ok && !R.isEmpty(response.data.data)) {
            let options = response.data.data.map((c) => mapToObjectDDL(c.variableName, c.systemId));
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: prevValue.dataTable.map((dt) => ({
                    ...dt,
                    systemId: options.find(item => item.value === dt.systemId),
                })),
                categoriesOptions: options
            }));
        }
    }

    handleGetTotalParameter = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                paramFilters: {
                    bizparCategory: this.props.state.selectedData.category
                },
                limit: 0, page: 1,
            })
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    totalParameter: response.data.totalData + 1,
                    pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.data.length,
                }
                }))
            }
        } catch (e) {
            console.log("error", e)
        }
    }

    handleAddParameter = () => {
        const newParameter = {
            key: this.props.state.selectedData.category.replace(/_/g, "") + ("0000" + this.state.totalParameter).slice(-4),
            value: "",
            bizparCategory: this.props.state.selectedData.category,
            systemId: this.state.categoriesOptions[0],
            saved: false,
        };
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: [...prevValue.dataTable, newParameter],
            totalParameter: prevValue.totalParameter + 1,
        }));
    };

    handleDeleteParameter = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: prevValue.dataTable.filter((_, idx) => idx !== index),
        }));
    };

    handleValueChange = (index, name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: prevValue.dataTable.map((data, idx) =>
                idx === index
                    ? {
                        ...data,
                        [name]: value,
                    }
                    : data
            ),
        }));
    };

    handleSaveParameter = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: prevValue.dataTable.map((data, idx) =>
                idx === index ? {...data, saved: !data.saved} : data
            ),
        }));
    };

    handleSubmit = () => {
        const data = this.state.dataTable.filter((data) => data.saved);
        if (!R.isEmpty(data)) {
            this.props.onSubmit(data);
        } else {
            this.props.onDeleteAll(this.props.state.selectedData.category);
        }
        this.setState((prevValue) => ({
            ...prevValue,
            totalParameter: null,
        }))
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <SimpleModal
                visible={this.props.state.detailVisible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_kategori_parameter"
                            label="Kategori Parameter"
                            readOnly
                            value={this.props.state.selectedData.category}
                        />
                        <SimpleButton
                            className="margin-bottom-10px margin-left-none"
                            onClick={this.handleAddParameter}
                        >
              <span>
                <i className="fa fa-plus margin-right-10px"></i>
              </span>
                            Tambah
                        </SimpleButton>
                        <SimpleDataTable
                            key={`${pagination.totalData}-${pagination.page}`}
                            data={this.state.dataTable}
                            columns={this.tableColumns}
                            toCount={pagination.totalData}
                            rowsPerPage={pagination.limit}
                            page={pagination.page - 1}
                            options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                        />
                        <div style={{textAlign: "right"}} className="margin-top-10px">
                            <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                        </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterParameterDetail;
